import { FieldValidator } from './field-validator'

export interface PasswordMatch {
    originalPassword: string
    confirmedPassword: string
}

export class ConfirmPasswordTextFieldValidator implements FieldValidator<PasswordMatch> {
    validate(value: PasswordMatch, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (!value.originalPassword || !value.confirmedPassword || value.originalPassword !== value.confirmedPassword) {
                reject('Passwords do not match.')
            } else {
                resolve('')
            }
        })
    }
}
